<template>
  <div class="messages-wrapper d-flex align-items-center">
    <template v-for="msg in messages" :key="msg.uuid">
      <div class="message z-index-master">
        <p :class="`alert alert-${msg.type} m-0 py-2 px-3`">
          {{ msg.message }}
          <span class="progress" :style="'width:' + progress(msg) + '%'" />
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import {Helpers} from "@/helpers";
import {v4 as uuidv4} from "uuid";

export default {
  name: 'ComponentMessages',
  data() {
    return {
      messages: [],
      ticker: null,
      now: Date.now(),
    }
  },
  methods: {
    createMessage(message, type, duration = 3000) {
      const pos = this.messages.length
      const uuid = uuidv4()
      const createdAt = Date.now()
      const endsAt = createdAt + duration
      this.messages.push({
        uuid,
        message: Array.isArray(message) ? message.join(' | ') : message,
        type,
        pos,
        createdAt,
        endsAt
      })
      setTimeout(() => {
        this.messages = this.messages.filter((msg) => msg.uuid !== uuid)
      }, duration)
    },
    progress(msg) {
      const total = msg.endsAt - msg.createdAt
      const left = msg.endsAt - this.now

      const pct = (left / total) * 100
      return Math.max(0, Math.min(100, pct))
    }
  },
  created() {
    this.ticker = setInterval(() => {
      this.now = Date.now()
    }, 30)

    // this.createMessage("foo", 'danger', 999999)

    Helpers.emitter.on('error', message => {
      this.createMessage(message, 'danger')
    })
    Helpers.emitter.on('warning', message => {
      this.createMessage(message, 'warning')
    })
    Helpers.emitter.on('success', message => {
      this.createMessage(message, 'info')
    })
  },
  beforeUnmount() {
    clearInterval(this.ticker)
  },
  computed: {

  }
}
</script>
<style lang="scss">
.messages-wrapper {
  flex-grow: 1;
  .message {
    margin-right: 0.5rem;
    width: 100%;
    .alert {
      border-radius: 0;
      position: relative;
      &.alert-info {
        .progress {
          border: 2px solid var(--bs-info-border-subtle);
        }
      }
      &.alert-warning {
        .progress {
          border: 2px solid var(--bs-warning-border-subtle);
        }
      }
      &.alert-danger {
        .progress {
          border: 2px solid var(--bs-danger-border-subtle);
        }
      }
      .progress {
        width: 50%;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
}

</style>